/**
 * Policy page enhancements: legacy CMS callout paragraphs and callout class support.
 */

class DevPolicy extends HTMLElement {
  #iconTemplate;

  connectedCallback() {
    this.#iconTemplate = document.getElementById('dev-policy-callout-icon-template');
    this.#enhanceCallouts();
  }

  #enhanceCallouts() {
    const content = this.querySelector('.dev-policy__content');
    if (!content) return;

    content.querySelectorAll('.dev-policy-callout').forEach((callout) => {
      this.#ensureCalloutIcon(callout);
    });

    content.querySelectorAll('p').forEach((paragraph) => {
      if (paragraph.closest('.dev-policy-callout')) return;
      if (!this.#isLegacyCalloutParagraph(paragraph)) return;

      const callout = document.createElement('div');
      callout.className = 'dev-policy-callout';

      const textWrap = document.createElement('div');
      textWrap.className = 'dev-policy-callout__text';

      paragraph.replaceWith(callout);
      callout.appendChild(textWrap);
      textWrap.appendChild(paragraph);

      this.#stripLeadingBreak(paragraph);
      this.#ensureCalloutIcon(callout);
    });
  }

  #ensureCalloutIcon(callout) {
    if (callout.querySelector('.dev-policy-callout__icon') || !this.#iconTemplate) return;

    const iconWrap = document.createElement('span');
    iconWrap.className = 'dev-policy-callout__icon';
    iconWrap.setAttribute('aria-hidden', 'true');
    iconWrap.appendChild(this.#iconTemplate.content.cloneNode(true));
    callout.prepend(iconWrap);
  }

  #isLegacyCalloutParagraph(paragraph) {
    if (paragraph.classList.contains('dev-policy-callout')) return false;

    const span = paragraph.querySelector(':scope > span');
    if (span?.firstElementChild?.tagName === 'BR') return true;

    const text = paragraph.textContent.trim();
    return text.startsWith('For details,');
  }

  #stripLeadingBreak(paragraph) {
    const span = paragraph.querySelector(':scope > span');
    const leadingBreak = span?.firstElementChild;
    if (leadingBreak?.tagName === 'BR') leadingBreak.remove();
  }
}

if (!customElements.get('dev-policy')) {
  customElements.define('dev-policy', DevPolicy);
}
